export default "__VITE_ASSET__BcdCVsQe__"